import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { usePerformance } from './hooks/usePerformance'

// Performance monitoring
const PerformanceWrapper = () => {
  usePerformance() // Initialize performance monitoring
  return <App />
}

export { PerformanceWrapper }

// Error tracking for unhandled errors
window.addEventListener('error', event => {
  if (import.meta.env.PROD) {
    // Send to error tracking service
    fetch('/api/errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'unhandled_error',
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error?.stack,
        timestamp: new Date().toISOString(),
        url: window.location.href,
        userAgent: navigator.userAgent,
      }),
    }).catch(() => {
      // Silently handle error tracking failures
    })
  }
})

// Unhandled promise rejection tracking
window.addEventListener('unhandledrejection', event => {
  if (import.meta.env.PROD) {
    fetch('/api/errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'unhandled_promise_rejection',
        reason: event.reason,
        timestamp: new Date().toISOString(),
        url: window.location.href,
        userAgent: navigator.userAgent,
      }),
    }).catch(() => {
      // Silently handle error tracking failures
    })
  }
})

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
  <StrictMode>
    <PerformanceWrapper />
  </StrictMode>
)
